import { useStore, useClientSettingStore } from './Store';

export class CompanyCompareUtils {
    static findCompaniesToCompare = (reportId: string, maxReturn = 2) => {
        const store = useStore();
        const clientStore = useClientSettingStore();
        const q = store.createDataAccess(reportId);

        if (q == null) return [];

        const companies = Object.keys(store.reportDataDB).filter(reportId => {
            if (store.reportDataDB[reportId].status != 'completed') {
                return false;
            }

            // Apply demo filter
            const filter_settings = clientStore.filterCompaniesForDemo;
            if (clientStore.isDemoFilterOn && filter_settings != null) {
                if (filter_settings[reportId] !== true) {
                    return false;
                }
            }

            return true;
        });

        const fullMatch = [];
        const partialMatch = [];
        const noMatch = [];

        const industry = q.value('industry');
        const subIndustry = q.value('industrySubType');

        companies.forEach(reportId => {
            const compA = store.createDataAccess(reportId);

            const otherIndustry = compA.value('industry');
            const otherSub = compA.value('industrySubType');

            if (store.selectedReportId == reportId) return;
            if (compA.report_has_pdf != true) return;

            if (industry == otherIndustry && subIndustry == otherSub) {
                fullMatch.push(reportId);
            } else if (industry == otherIndustry) {
                partialMatch.push(reportId);
            } else {
                noMatch.push(reportId);
            }
        });

        var allCompanies = fullMatch.concat(partialMatch).concat(noMatch);
        return allCompanies.slice(0, maxReturn);
    };
}
